module.exports = {
	"header": "Features",
	"headerSmall": "Publish your auctions on $t(general::brand)",
	"pricing": "__type__ pricing",
	"auctionSetup": {
		"header": "Auction setup",
		"lotLimit": "Number of lots per auction:",
		"pictureLimit": "Number of pictures per lot:",
		"imageHosting": "Image hosting"
	},
	"marketing": {
		"header": "Marketing",
		"orgPremium": "Business listed as a premium auctioneer in directory",
		"auctionPremium": "Auction displayed in featured auctions for more visiblity"
	},
	"support": {
		"header": "Support",
		"catalogProduction": "Catalog Production Assistance",
		"catalogProductionTooltip": "We can provide you one on one phone or email support for the creation and management of your auction catalog.",
		"phone": "Phone Support",
		"email": "E-mail support"
	},
	"soon": {
		"header": "Upcoming Feature",
		"availableSoon": "This feature will be available soon. Please come back later.",
		"contactUs": "For more information or support you can <a>contact us</a>."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/features.json5
// module id = 1930
// module chunks = 6